import Vue from 'vue'
import config from '../../config/config.json'
import store from '../store'
import Screenshot from '../../models/screenshot'
import eventBus from '../../services/event-bus'

function onlyUnique (value, index, array) {
  return array.indexOf(value) === index
}

export default{
  namespaced: true,
  state: {
    all: [],
    requests: [],
    allUsers: []
  },
  getters: {
    all: state => state.all,
    users: state => state.all.map((screenshot) => screenshot.username).filter(onlyUnique),
    latest: (state, getters) => {
      let result = {}
      getters.users.map((user) => {
        let screenshot = state.all.filter((screenshot) => screenshot.username === user)[0]
        if (screenshot !== null) {
          result[user] = screenshot
        }
      })
      return result
    }
    /**
    latest2: (state, getters) => getters.users.map((user) => {
      return {
        user: state.all.filter((screenshot) => screenshot.user[0])
      }
    })
      **/
  },
  mutations: {
    SET_ALL (state, screenshots) {
      state.all = screenshots
    },
    ADD (state, screenshot) {
      state.all.unshift(screenshot)
      // state.all.push(screenshot)
      if (state.allUsers.indexOf(screenshot.user) < 0) {
        state.allUsers.push(screenshot.user)
      }
    },
    ADD_MULTIPLE (state, screenshots) {
      for (var i in screenshots) {
        console.log(screenshots[i])
        state.all.push(screenshots[i])
      }
      console.log(state.all)
    },
    CLEAR (state, screenshot) {
      state.all = []
    },
    ADD_REQUEST (state, request) {
      state.requests.push(request)
      console.log(state.requests)
    },
    CLEAR_REQUEST (state, rid) {
    },
    ADD_USER (state, user) {
      state.allUsers.push(user)
    }
  },
  actions: {
    initPusher ({dispatch, commit}) {
      this.$channels.screen.bind('screenshot.available', (payload) => {
        console.log('A screenshot has become available')
        dispatch('screenshotAvailable', Screenshot.fromJson(payload))
      })
      this.$channels.screen.bind('screenshot.requested', (payload) => {
        // dispatch('motionStateChanged', payload)
      })
      this.$channels.user.bind('screenshot.requested', (payload) => {
        console.log('A screenshot has been requested')
        // dispatch('motionStateChanged', payload)
      })
      eventBus.$emit('screenshotRequested', {rid: '123'})
    },
    screenshotAvailable ({commit, dispatch}, payload) {
      commit('ADD', payload)
      if (payload.rid !== null) {
        console.log('screenshot has an rid')
      }
    },
    async loadInitial ({commit, dispatch}) {
      const host = process.env.NODE_ENV === 'production' ? config.url_monitor : config.url_monitor_dev

      let response = await Vue.http.get(
        `${host}/screenshots`,
        {
          headers: {
            'Authorization': `Bearer ${store.getters['auth/token']}`
          }
        }
      )
      console.log(response)
      let screenshots = response.body.body.data.map((d) => Screenshot.fromJson(d))
      console.log(screenshots)
      commit('ADD_MULTIPLE', screenshots)
    },
    async upload ({commit, dispatch}, payload) {
      const host = process.env.NODE_ENV === 'production' ? config.url_monitor : config.url_monitor_dev

      Vue.http.post(
        `${host}/screenshots`,
        payload,
        {
          headers: {
            'Authorization': `Bearer ${store.getters['auth/token']}`
          }
        }
      )
    },
    async request ({commit, dispatch}, username) {
      const host = process.env.NODE_ENV === 'production' ? config.url_monitor : config.url_monitor_dev
      // let path = username !== null ? `${config.url_monitor}/screenshots/request/${username}`
      //  : `${config.url_monitor}/screenshots/request`
      let response = await Vue.http.post(
        `${host}/screenshots/request/${username}`,
        {},
        {
          headers: {
            'Authorization': `Bearer ${store.getters['auth/token']}`
          }
        }
      )

      let request = {
        id: response.body.body.rid,
        requestedAt: Date.now()
      }

      commit('ADD_REQUEST', request)

      // eventBus.$emit('screenshotRequested', {rid: '123'})

      return response
    },
    async requestAll ({commit, dispatch}) {
      let response = await Vue.http.post(
        `${config.url_monitor}/screenshots/request`,
        {},
        {
          headers: {
            'Authorization': `Bearer ${store.getters['auth/token']}`
          }
        }
      )
      return response
    },
    cleanup ({state, commit}) {
      let screenshots = []
      for (let i in state.all) {
        let diffInMs = Date.now() - state.all[i].createdAt
        let diffInMins = diffInMs / 1000 / 60
        // console.log(diffInMins)
        if (diffInMins < 120) {
          // print(differenceInMinutes(screenshots[i], Date.now()))
          screenshots.push(state.all[i])
        }
      }
      state.all = screenshots
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/screenshots.js